//url api do ktorego sie laczymy
//export const FLOW_API_SERVER = "http://localhost:7795/api/v1";

const VERSION = "/v1";

//users
export const USERS_URL = `${VERSION}/users`;
export const ME_URL = "/me";
export const USER_CREDENTIALS_URL = (userId) => `${USERS_URL}/${userId}/credentials`;

export const ROLES_URL = `${VERSION}/roles`;
export const NETWORKS_URL = `${VERSION}/networks`;
export const CONNECTIONS_URL = `${VERSION}/connections`;
export const GLOBAL_PARAMS_URL = `${VERSION}/globalParams`;

//restaurants
export const RESTAURANTS_URL = `${VERSION}/restaurants`;
export const RESTAURANT_PAYMENTS_URL = (restaurantId) => `${RESTAURANTS_URL}/${restaurantId}/payments`;

//credentials
export const CREDENTIALS_URL = `${VERSION}/credentials`;
export const RESET_PASSWORDS_URL = CREDENTIALS_URL + "/byResetPasswordToken";

export const AUTH_URL = `${VERSION}/authentication`;

//reset password
export const RESET_PASSWORD_TOKENS_URL = `${VERSION}/resetPasswordTokens`;
export const FORGOT_PASSWORDS_URL = RESET_PASSWORD_TOKENS_URL + "/byUser";
export const PASSWORDS_BY_TOKEN_URL = RESET_PASSWORD_TOKENS_URL + "/byToken";

//payments
export const OVERDUE_PAYMENTS_URL = `${VERSION}/payments/overdue`;

//p24 transactions
export const P24_TRANSACTIONS_URL = `${VERSION}/p24/transactions`;
export const P24_TRANSACTIONS_BY_FILTER_URL = `${VERSION}/p24/transactions/byFilter`;
export const P24_TRANSACTION_URL = (transactionId) =>  `${VERSION}/p24/transactions/${transactionId}`;
export const P24_TRANSACTION_DATA_BY_P24_URL = (transactionId) =>  `${VERSION}/p24/transactions/${transactionId}/byP24`;
export const P24_TRANSACTION_REFUNDS_DATA_BY_P24_URL = (transactionId) =>  `${VERSION}/p24/transactions/${transactionId}/byP24/refunds`;
export const P24_TRANSACTION_REFUNDS_URL = (transactionId) =>  `${VERSION}/p24/transactions/${transactionId}/refunds`;
export const P24_TRANSACTION_PAYMENT_METHOD_BLIK_CHARGE_BY_CODE_URL = (transactionId) =>  `${VERSION}/p24/transactions/${transactionId}/paymentMethods/blik/chargeByCode`;
export const P24_TRANSACTION_REFUND_URL = (transactionId) =>  `${VERSION}/p24/transactions/${transactionId}/refunds`;

//p24 transaction logs
export const P24_TRANSACTION_LOGS_URL = (transactionId) => `${VERSION}/p24/transactions/${transactionId}/logs`;


//p24 restaurant cheque transactions
export const P24_RESTAURANT_CHEQUE_TRANSACTIONS_BY_FILTER_URL = (restaurantId) => `${VERSION}/p24/restaurants/${restaurantId}/chequeTransactions/byFilter`;

//p24 restaurant logs
export const P24_RESTAURANT_LOGS_BY_FILTER_URL = (restaurantId) => `${VERSION}/p24/restaurants/${restaurantId}/logs/byFilter`;

//p24 merchants
export const P24_MERCHANTS_URL = `${VERSION}/p24/merchants`;
export const P24_MERCHANTS_BY_ID_URL = (id) => `${VERSION}/p24/merchants/${id}`;
export const P24_MERCHANTS_BY_NIP_URL = (nip) => `${VERSION}/p24/merchants/byNip/${nip}`;
export const P24_MERCHANTS_BY_PESEL_URL = (pesel) => `${VERSION}/p24/merchants/byPesel/${pesel}`;
export const P24_MERCHANTS_BY_P24_MERCHANT_ID_URL = (p24MerchantId) => `${VERSION}/p24/merchants/byP24MerchantId/${p24MerchantId}`;
export const P24_MERCHANT_TEST_CONNECTION_URL = (merchantId) => `${P24_MERCHANTS_URL}/${merchantId}/testConnection`;
export const P24_MERCHANT_PAYMENT_METHODS_URL = (merchantId) => `${P24_MERCHANTS_URL}/${merchantId}/paymentMethods`;

//p24 restaurant merchant
export const P24_RESTAURANT_MERCHANT_URL = (restaurantId) => `${VERSION}/restaurants/${restaurantId}/merchant`;
export const P24_RESTAURANT_MERCHANT_BY_ID_URL = (restaurantId, merchantId) => `${VERSION}/restaurants/${restaurantId}/merchant/${merchantId}`;

//p24 logs
export const P24_LOGS_URL = `${VERSION}/p24/logs`;
export const P24_LOGS_BY_FILTER_URL = `${VERSION}/p24/logs/byFilter`;

//p24 flow server
export const FLOW24_SERVER_CONFIG_URL = `${VERSION}/flow24/config`;

//klucz pod jakim zapisujemy token autoryzacyjny w localeStorage
export const LOCALE_STORAGE_TOKEN_KEY = "flow24token";
